module.exports = __webpack_public_path__ + "img/document-icon-blue.d7b7c763.svg";